export default function getHashStringUtil (str) {
  return `#${str}`
}
